import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Field from 'components/setupform-form/field'
import TextInput from 'components/setupform-form/field/text-input'
import FieldError from 'components/setupform-form/field/field-error'
import InputDateTimeLocal from 'components/setupform-form/field/input-date-time-local'
import styles from './setupform-vouchers-form.css'

const SetupformVouchersForm = ({ fields }) => (
  <form styleName="setupform-vouchers-form">
    <Field
      name="Voucher name"
    >
      <TextInput data={fields.ticketType} placeholder="Bottle of awesome sauce" />
      <FieldError data={fields.ticketType} />
    </Field>

    <Field
      name="Quantity"
    >
      <TextInput data={fields.ticketCount} placeholder="e.g. 1000" />
      <FieldError data={fields.ticketCount} />
    </Field>

    <Field
      name="Voucher valid from"
    >
      <InputDateTimeLocal data={fields.voucherValidFrom} />
      <FieldError data={fields.voucherValidFrom} />
    </Field>

    <Field
      name="Voucher valid to"
    >
      <InputDateTimeLocal data={fields.voucherValidTo} />
      <FieldError data={fields.voucherValidTo} />
    </Field>

    <Field
      name="Onsale time"
    >
      <InputDateTimeLocal data={fields.onsaleTime} />
      <FieldError data={fields.onsaleTime} />
    </Field>

    <Field
      name="Offsale time"
    >
      <InputDateTimeLocal data={fields.offsaleTime} />
      <FieldError data={fields.offsaleTime} />
    </Field>

    <Field
      name="Face value"
      description="The price that a customer would pay if they bought the product elsewhere"
    >
      <TextInput data={fields.initialPrice} placeholder="e.g. 50" />
      <FieldError data={fields.initialPrice} />
    </Field>

    <Field
      name="Sale price"
      description="The price that a customer pays for the product"
    >
      <TextInput data={fields.discountPrice} placeholder="e.g. 30" />
      <FieldError data={fields.discountPrice} />
    </Field>

    <Field
      name="Commission %"
      description=""
    >
      <TextInput data={fields.commission} placeholder="e.g. 20" />
      <FieldError data={fields.commission} />
    </Field>
  </form>
)

SetupformVouchersForm.propTypes = {
  fields: PropTypes.object,
}

export default CSSModules(SetupformVouchersForm, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-vouchers-form/setupform-vouchers-form.js
 **/